import React from 'react';
import { Routes, Route } from 'react-router-dom';
import InspectionsList from './InspectionsList';
import InspectionForm from './InspectionForm';

export default function InspectionsModule() {
  return (
    <Routes>
      <Route path="/" element={<InspectionsList />} />
      <Route path="add" element={<InspectionForm />} />
      <Route path=":id" element={<InspectionForm />} />
      <Route path=":id/edit" element={<InspectionForm />} />
    </Routes>
  );
}
